<template>
  <v-container>
    <h1>ACSW Annual Membership Dues Payment</h1>
    <h2>Total Fees to renew until {{ renewDate }}: AUD {{ fee }}</h2>
    <v-row>
      <v-col cols="12" sm="6">
        <v-card>
          <v-col cols="12" sm="8">
          <v-row><v-text-field disabled label="Member #" v-model="mNbr"></v-text-field></v-row>
          <v-row><v-text-field disabled label="Member Name" v-model="mName"></v-text-field></v-row>
          <v-row><v-text-field disabled label="Member Email" v-model="email"></v-text-field></v-row>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          Payment Methods
          <div v-show="showPP">
            <iframe id="ppmtWin" src="" title="pp pmt" width="250" height="190"></iframe>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-btn @click="pay">{{btnTxt}}</v-btn>

  </v-container>
</template>

<script>
var myThis = null
window.document.addEventListener('myEvent', handleEvent, false)
//import Axios from 'axios'

function handleEvent(e) {
  console.log(e.detail)
  //alert('Thank You ' + e.detail.payer.name.given_name + ' ' + e.detail.payer.name.surname)
  let theToken = localStorage.getItem('token')
  if (theToken == null) {
    // alert('You must log in to access this feature')
    this.$router.push('/')
  }
  try {
    myThis.mbr.renewedThru = myThis.newRenewDate
    myThis.$http.post(this.$remote + '/api/modmbr', {mbr: myThis.mbr, token: myThis.$usrStore.token})
        .then(resp => {
          myThis.$usrStore.token = resp.data.token
          console.log(resp)
          alert('Your renewal has been recorded\nPlease log in again')
          myThis.$router.push('logout')
        })
/*
    let resp = await this.$http.post(this.$remote + '/api/modmbr', {
      token: theToken, mbr: this.mbr
    })

    console.log(resp)
    alert('Your renewal has been recorded\nPlease log in again')
    this.$router.push('logout')
 */
  } catch (e) {
    alert(`Update failed. Please contact info@acsw.com.au.\n${e}`)
  }
}

export default {
  name: "Renew",
  props: {
    theItem: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    showPP: false,
    dis: true,
    mbr: {},
    poster: null,
    newRenewDate: null
  }),
  methods: {
    pay: function () {
      myThis = this
      if (this.showPP) {
        this.showPP = false
        document.getElementById('ppmtWin').setAttribute('src', '')
      } else {
        let theToken = localStorage.getItem('token')
        if (theToken == null) {
          // alert('You must log in to access this feature')
          this.$router.push('/')
        }
      this.poster = this.$http
        this.newRenewDate = this.$usrStore.toRenew.newRenewDate
        this.$http.post(this.$remote + '/api/mbr2', {
          token: theToken, mNbr: this.$usrStore.mNbr
        }). then ( resp => {
          this.$usrStore.token = resp.data.token
          this.mbr = resp.data.mbr
          const toRenew = this.$usrStore.toRenew
          const amount = toRenew.rejoinFee + toRenew.renewFee
          //const rdt = toRenew.newRenewDate
          //const rdtAU = this.$iso2AU(rdt)

          document.getElementById('ppmtWin').setAttribute(
              'src',
              `ppmt2.html?amt=${amount}&mbr=${this.$usrStore.mNbr}`
          )
          this.showPP = true
        })
      }
    }
  },
  computed: {
    mNbr: {
      get() {
        return this.$usrStore.mNbr
      },
    },
      mName: {
        get() {
          return this.$usrStore.name
        }
    },
    email: {
      get() {
        return this.$usrStore.email
      }
    },
    renewDate: {
      get() {
        return this.$iso2AU(this.$usrStore.toRenew.newRenewDate)
      }
    },
    fee: {
      get() {
        return this.$usrStore.toRenew.rejoinFee + this.$usrStore.toRenew.renewFee
      }
    },
    btnTxt: {
      get() {
        return 'Click here to renew now. Then select a Payment Method'
      }
    }
  },
}

</script>

<style scoped>

</style>
